/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
// import { IconContext } from "react-icons";
// import { FaUserAlt as User } from "react-icons/fa";
import { NavLink, useLocation } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";
import MainButton from "../common/MainButton/MainButton";
import Avtar from "../../assets/img/default-image.jpg";
// import "./header.css";
import useAuth from "../../Hooks/useAuth";
import AuxiliaryText from "../common/Typography/AuxiliaryText";
import useClickOutside from "../../Hooks/useClickOutside";
import InteractiveText from "../common/Typography/InteractiveText";
import SpecialText from "../common/Typography/SpecialText";
import { useSelector, useDispatch } from 'react-redux';
import { setRedirectPath } from '../../Redux/Slice/authRedirectSlice';
import QuoteRequestForm from '../QuoteRequestForm/QuoteRequestForm';
const CustomerNavbar = ({
  isMobile,
  toggleDrawer,
  setSignUpState,
  SignUpState,
  setSignIn,
  SignIn,
  hideCategoriesAndPricing = false,
}) => {
  const location = useLocation();
  const [settings, setSettings] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const [inboxOpen, setInboxOpen] = useState(false);
  const [notificationsAlerts, setNotificationsAlerts] = useState(false);
  const [quoteRequestOpen, setQuoteRequestOpen] = useState(false);
  const [pendingQuoteRequest, setPendingQuoteRequest] = useState(false);
  const { auth, setAuth } = useAuth();
  const [IsHomePage, setIsHomePage] = useState(
    location.pathname === "/" ? true : false
  );
  const [categories, setCategories] = useState(
    location.hash === "#categorie" ? true : false
  );
  const [packages, setPackages] = useState(
    location === "/pricing" ? true : false
  );
  const dispatch = useDispatch();

  const { id: userId } = auth?.user ?? "";
  useEffect(() => {
    setIsHomePage(
      location.pathname === "/" && location.hash === "" ? true : false
    );
    setCategories(
      location.pathname === "/" && location.hash === "#categorie" ? true : false
    );
    setPackages(location.pathname === "/pricing" ? true : false);
  }, [location, IsHomePage, categories, packages]);

  // Handle automatic quote request form opening after login redirect
  useEffect(() => {
    if (auth?.user && pendingQuoteRequest) {
      setQuoteRequestOpen(true);
      setPendingQuoteRequest(false);
    }
  }, [auth?.user, pendingQuoteRequest]);

  // Handle Get free Quotes button click
  const handleRequestQuote = () => {
    if (auth?.user) {
      setQuoteRequestOpen(true);
    } else {
      setPendingQuoteRequest(true);
      dispatch(setRedirectPath(location.pathname + location.search));
      setSignIn(true);
    }
  };

  const ref = useRef(null);
  useClickOutside(ref, () => {
    setNotificationsAlerts(false);
  });
  return (
    <>
      {/* Quote Request Form Popup */}
      <QuoteRequestForm
        isOpen={quoteRequestOpen}
        onClose={() => setQuoteRequestOpen(false)}
      />
      
      <nav
        className={`${
          isMobile
            ? "items-center flex-col overflow-hidden"
            : "items-center flex-row"
        } flex menuItems`}
      >
        <ul
          className={`${
            isMobile ? "items-center flex-col" : "items-center flex-row"
          } flex menuItems`}
        >
          {!hideCategoriesAndPricing && (
            <>
              <li className="lg:mr-8 mb-1 lg:mb-0 relative hover:text-primaryblue  px-2 lg:px-0 py-2 lg:py-0 block ">
                <NavHashLink
                  to="/#categorie"
                  spy={true}
                  smooth={true}
                  offset={-88}
                  duration={500}
                  onClick={toggleDrawer}
                  className={`cursor-pointer  ${
                    categories ? " text-primaryblue " : ""
                  }`}
                >
                  <AuxiliaryText variant={"NavigationText"}>
                    Categories
                  </AuxiliaryText>
                  {/* <MainButton variant={"medium"} className={"hidden lg:block"}>
                    Categories
                  </MainButton>
                  <MainButton variant={"large"} className={"lg:hidden"}>
                    Categories
                  </MainButton> */}
                </NavHashLink>
              </li>
              <li className="lg:mr-8 mb-1 lg:mb-0 relative hover:text-primaryblue  px-2 lg:px-0 py-2 lg:py-0 block ">
                <NavLink
                  to={"/pricing"}
                  onClick={toggleDrawer}
                  className={`cursor-pointer  ${
                    packages ? " text-primaryblue " : ""
                  }`}
                >
                  <AuxiliaryText variant={"NavigationText"}>
                    Pricing
                  </AuxiliaryText>
                </NavLink>
              </li>
            </>
          )}
          <li className="lg:mr-8 mb-1 lg:mb-0 relative hover:text-primaryblue px-2 lg:px-0 py-2 lg:py-0 lg:hidden">
            <NavLink
              to={"/HelpCentre"}
              onClick={toggleDrawer}
              className={`cursor-pointer  ${
                packages ? " text-primaryblue " : ""
              }`}
            >
              <AuxiliaryText variant={"NavigationText"}>
                Help
              </AuxiliaryText>
            </NavLink>
          </li>
        </ul>
      </nav>
      {auth?.user?.emailConfirmed && (
        <ul className="flex items-center gap-5 ml-10">
          <li
            className="cursor-pointer hover:bg-transparent hidden lg:block relative"
            ref={ref}
          >
            <i
              className="fi fi-rs-bell text-base cursor-pointer"
              onClick={() => setNotificationsAlerts(!notificationsAlerts)}
            ></i>
            {notificationsAlerts && (
              <div className="absolute z-10 w-[350px] origin-top-right rounded-xl bg-white text-offblack pt-5 pb-10 mt-3 -right-14 shadow-2xl">
                <div
                  class="w-0 h-0 
  border-l-[10px] border-l-transparent
  border-b-[15px] border-b-white
  border-r-[10px] border-r-transparent absolute left-[275px] -mt-8"
                ></div>
                {/* Heading */}
                <div className="flex items-center justify-between px-5 mb-5">
                  <AuxiliaryText variant={"MenuDropdown"}>
                    Notifications
                  </AuxiliaryText>
                  {/* <Link to={"/customer-dashboard/inbox/notifications"}>
                    <InteractiveText
                      variant={"ActionLink"}
                      className={"text-primaryblue"}
                    >
                      View all
                    </InteractiveText>
                  </Link> */}
                </div>

                {/* Notifications list */}
                <div className="border-t border-t-lightgray mx-5">
                  <div className="border-b border-b-lightgray py-3 relative">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-x-2">
                        <img
                          src={Avtar}
                          className="w-6 h-6 rounded-full object-cover"
                        />
                        <AuxiliaryText variant={"MenuDropdown"} >
                          Trades poster
                        </AuxiliaryText>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="fi fi-ss-bullet text-base text-primaryblue pt-1"></i>
                        <SpecialText
                          variant={"Date"}
                          className={"text-mediumgray"}
                        >
                          1 minute ago
                        </SpecialText>
                      </div>
                    </div>
                    <AuxiliaryText
                      variant={"SubMenuDropdown"}
                      className={"h-[20px] overflow-hidden text-ellipsis mt-2"}
                    >
                      Ensure seamless transactions and keep your business
                      running smoothly with our straightforward billing section.
                      Add/ remove payment methods, track and maintain record of
                      all your pricing plans transactions with Trades Poster
                    </AuxiliaryText>
                  </div>
                  <div className="border-b border-b-lightgray py-3 relative">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-x-2">
                        <img
                          src={Avtar}
                          className="w-6 h-6 rounded-full object-cover"
                        />
                       <AuxiliaryText variant={"MenuDropdown"} >
                          Trades poster
                        </AuxiliaryText>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="fi fi-ss-bullet text-base text-primaryblue pt-1"></i>
                        <SpecialText
                          variant={"Date"}
                          className={"text-mediumgray"}
                        >
                          1 minute ago
                        </SpecialText>
                      </div>
                    </div>
                    <AuxiliaryText 
                      variant={"SubMenuDropdown"}
                      className={"h-[20px] overflow-hidden text-ellipsis mt-2"}
                    >
                      Ensure seamless transactions and keep your business
                      running smoothly with our straightforward billing section.
                      Add/ remove payment methods, track and maintain record of
                      all your pricing plans transactions with Trades Poster
                    </AuxiliaryText>
                  </div>
                  <div className="border-b border-b-lightgray py-3 relative">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-x-2">
                        <img
                          src={Avtar}
                          className="w-6 h-6 rounded-full object-cover"
                        />
                       <AuxiliaryText variant={"MenuDropdown"} >
                          Trades poster
                        </AuxiliaryText>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="fi fi-ss-bullet text-base text-primaryblue pt-1"></i>
                        <SpecialText
                          variant={"Date"}
                          className={"text-mediumgray"}
                        >
                          1 minute ago
                        </SpecialText>
                      </div>
                    </div>
                    <AuxiliaryText
                      variant={"SubMenuDropdown"}
                      className={"h-[20px] overflow-hidden text-ellipsis mt-2"}
                    >
                      Ensure seamless transactions and keep your business
                      running smoothly with our straightforward billing section.
                      Add/ remove payment methods, track and maintain record of
                      all your pricing plans transactions with Trades Poster
                    </AuxiliaryText>
                  </div>
                  <div className="border-b border-b-lightgray py-3 relative">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-x-2">
                        <img
                          src={Avtar}
                          className="w-6 h-6 rounded-full object-cover"
                        />
                      <AuxiliaryText variant={"MenuDropdown"} >
                          Trades poster
                        </AuxiliaryText>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="fi fi-ss-bullet text-base text-primaryblue pt-1"></i>
                        <SpecialText
                          variant={"Date"}
                          className={"text-mediumgray"}
                        >
                          1 minute ago
                        </SpecialText>
                      </div>
                    </div>
                    <AuxiliaryText 
                      variant={"SubMenuDropdown"}
                      className={"h-[20px] overflow-hidden text-ellipsis mt-2"}
                    >
                      Ensure seamless transactions and keep your business
                      running smoothly with our straightforward billing section.
                      Add/ remove payment methods, track and maintain record of
                      all your pricing plans transactions with Trades Poster
                    </AuxiliaryText>
                  </div>
                </div>
              </div>
            )}
          </li>
          <li className="cursor-pointer hover:bg-transparent hidden lg:block">
            <Link to={"/customer-dashboard/inbox/chats"}>
              <i className="fi fi-rs-comment-alt-dots text-base "></i>
            </Link>
          </li>
        </ul>
      )}

      <div className="flex items-center justify-center lg:hidden w-full">
        {!auth?.user ? (
          <>
            <div className="grid grid-cols-1">
              <span
                className="lg:mr-8 mb-6 lg:mb-0 cursor-pointer hover:text-primaryblue px-2 py-1 text-center"
                onClick={() => {
                  setSignIn(!SignIn);
                }}
              >
                <AuxiliaryText variant={"NavigationText"}>
                  Log in
                </AuxiliaryText>
              </span>
              <MainButton
                variant={"large"}
                onClick={() => {
                  toggleDrawer();
                  setSignUpState(!SignUpState);
                }}
              >
                Sign up for free
              </MainButton>
              {/* <MainButton
                variant={"outlinesmall"}
                className={"hidden lg:block"}
                onClick={() => {
                  toggleDrawer();
                  setSignUpState(!SignUpState);
                }}
              >
                Sign up
              </MainButton> */}
              {/* <MainButton
                variant={"outlinemedium"}
                className={"lg:hidden"}
                onClick={() => {
                  toggleDrawer();
                  setSignUpState(!SignUpState);
                }}
              >
                Sign up
              </MainButton> */}
            </div>
          </>
        ) : (
          <>
            <div className="pt-4 pb-3 w-full flex flex-col justify-center">
              {/* Get free Quote button now integrated into navigation menu */}
              
              <div className="flex items-center justify-center h-12 w-12">
                <div className="flex-shrink-0">
                  <img
                    className="h-12 w-12 rounded-full"
                    src={Avtar}
                    alt="Tradeposter User"
                  />
                </div>
                {/* <div className="">
                  <div className="text-sm font-medium leading-none ">
                    {auth?.user?.email ?? "No Email"}
                  </div>
                </div> */}
              </div>
              {/* <AuxiliaryText variant={"MenuDropdown"}></AuxiliaryText> */}
              <div className="mt-3 space-y-1 flex flex-col items-center">
                <Link
                  to={`/customer-dashboard/dashboard?userId=${userId}`}
                  onClick={() => toggleDrawer()}
                  className="block py-2  hover:text-primaryblue  px-2"
                >
                  <AuxiliaryText variant={"MenuDropdown"}>
                    Customer dashboard
                  </AuxiliaryText>
                </Link>
                <Link
                  to={`/customer-dashboard/account?userId=${userId}`}
                  onClick={() => toggleDrawer()}
                  className="block py-2  hover:text-primaryblue  px-2"
                >
                  <AuxiliaryText variant={"MenuDropdown"}>
                    Account
                  </AuxiliaryText>
                </Link>
                <Link
                  to={`/customer-dashboard/posts?userId=${userId}`}
                  onClick={() => toggleDrawer()}
                  className="block py-2  hover:text-primaryblue  px-2"
                >
                  <AuxiliaryText variant={"MenuDropdown"}>Posts</AuxiliaryText>
                </Link>
                <button
                  onClick={() => {
                    setSettings(!settings);
                    setInboxOpen(false);
                    setHelpOpen(false);
                  }}
                  className="flex justify-between px-2 py-2 hover:text-primaryblue  w-[180px] my-1"
                >
                  <AuxiliaryText variant={"MenuDropdown"}>
                    Settings
                  </AuxiliaryText>
                  <svg
                    sidebar-toggle-item
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
                {settings && (
                  <>
                    <ul className="text-center px-5">
                      <li>
                        <Link
                          to={`/customer-dashboard/settings/mobile?userId=${userId}`}
                          onClick={() => {
                            toggleDrawer();
                            setSettings(!settings);
                          }}
                          className="block px-2 py-2 hover:text-primaryblue  w-full my-1"
                        >
                          <AuxiliaryText variant={"SubMenuDropdown"}>
                            Mobile
                          </AuxiliaryText>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/customer-dashboard/settings/email?userId=${userId}`}
                          onClick={() => {
                            toggleDrawer();
                            setSettings(!settings);
                          }}
                          className="block px-2 py-2 hover:text-primaryblue  w-full my-1"
                        >
                          <AuxiliaryText variant={"SubMenuDropdown"}>
                            Email
                          </AuxiliaryText>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/customer-dashboard/settings/notification-preferences?userId=${userId}`}
                          onClick={() => {
                            toggleDrawer();
                            setSettings(!settings);
                          }}
                          className="block px-2 py-2 hover:text-primaryblue  w-full my-1"
                        >
                          <AuxiliaryText variant={"SubMenuDropdown"}>
                            Notifications
                          </AuxiliaryText>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/customer-dashboard/settings/reset-password?userId=${userId}`}
                          onClick={() => {
                            toggleDrawer();
                            setSettings(!settings);
                          }}
                          className="block px-2 py-2 hover:text-primaryblue  w-full my-1"
                        >
                          <AuxiliaryText variant={"SubMenuDropdown"}>
                            Reset Password
                          </AuxiliaryText>
                        </Link>
                      </li>
                    </ul>
                  </>
                )}
                <button
                  onClick={() => {
                    setInboxOpen(!inboxOpen);
                    setHelpOpen(false);
                  }}
                  className="flex justify-between px-2 py-2 hover:text-primaryblue  w-[180px] my-1"
                >
                  <AuxiliaryText variant={"MenuDropdown"}>Inbox</AuxiliaryText>
                  <svg
                    sidebar-toggle-item
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
                {inboxOpen && (
                  <>
                    <ul className="text-center px-5">
                      <li>
                        <Link
                          to={`/customer-dashboard/inbox/chats?userId=${userId}`}
                          onClick={() => {
                            toggleDrawer();
                            setInboxOpen(!inboxOpen);
                          }}
                          className="block px-2 py-2 hover:text-primaryblue  w-full my-1"
                        >
                          <AuxiliaryText variant={"SubMenuDropdown"}>
                            Messages
                          </AuxiliaryText>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/customer-dashboard/inbox/notifications?userId=${userId}`}
                          onClick={() => {
                            toggleDrawer();
                            setInboxOpen(!inboxOpen);
                          }}
                          className="block px-2 py-2 hover:text-primaryblue  w-full my-1"
                        >
                          <AuxiliaryText variant={"SubMenuDropdown"}>
                            Notifications
                          </AuxiliaryText>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/customer-dashboard/inbox/reviews?userId=${userId}`}
                          onClick={() => {
                            toggleDrawer();
                            setInboxOpen(!inboxOpen);
                          }}
                          className="block px-2 py-2 hover:text-primaryblue  w-full my-1"
                        >
                          <AuxiliaryText variant={"SubMenuDropdown"}>
                            Reviews
                          </AuxiliaryText>
                        </Link>
                      </li>
                    </ul>
                  </>
                )}
                <button
                  onClick={() => {
                    setHelpOpen(!helpOpen);
                    setInboxOpen(false);
                  }}
                  className="flex justify-between px-2 py-2 hover:text-primaryblue  w-[180px] my-1"
                >
                  <AuxiliaryText variant={"MenuDropdown"}>
                    Support
                  </AuxiliaryText>
                  <svg
                    sidebar-toggle-item
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
                {helpOpen && (
                  <>
                    <ul className="text-center px-5">
                      <li>
                        <Link
                          to={`/AboutUs?userId=${userId}`}
                          onClick={() => {
                            toggleDrawer();
                            setHelpOpen(!helpOpen);
                          }}
                          className="block px-2 py-2 hover:text-primaryblue  w-full my-1"
                        >
                          <AuxiliaryText variant={"SubMenuDropdown"}>
                            About
                          </AuxiliaryText>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/contact?userId=${userId}`}
                          onClick={() => {
                            toggleDrawer();
                            setHelpOpen(!helpOpen);
                          }}
                          className="block px-2 py-2 hover:text-primaryblue  w-full my-1"
                        >
                          <AuxiliaryText variant={"SubMenuDropdown"}>
                            Contact
                          </AuxiliaryText>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/Blogs?userId=${userId}`}
                          onClick={() => {
                            toggleDrawer();
                            setHelpOpen(!helpOpen);
                          }}
                          className="block px-2 py-2 hover:text-primaryblue  w-full my-1"
                        >
                          <AuxiliaryText variant={"SubMenuDropdown"}>
                            Blog
                          </AuxiliaryText>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/HelpCentre`}
                          onClick={() => {
                            toggleDrawer();
                            setHelpOpen(!helpOpen);
                          }}
                          className="block px-2 py-2 hover:text-primaryblue  w-full my-1"
                        >
                          <AuxiliaryText variant={"SubMenuDropdown"}>
                            Help centre
                          </AuxiliaryText>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/TermsConditions?userId=${userId}`}
                          onClick={() => {
                            toggleDrawer();
                            setHelpOpen(!helpOpen);
                          }}
                          className="block px-2 py-2 hover:text-primaryblue  w-full my-1"
                        >
                          <AuxiliaryText variant={"SubMenuDropdown"}>
                            Terms & Conditions
                          </AuxiliaryText>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`/PrivacyPolicy?userId=${userId}`}
                          onClick={() => {
                            toggleDrawer();
                            setHelpOpen(!helpOpen);
                          }}
                          className="block px-2 py-2 hover:text-primaryblue  w-full my-1"
                        >
                          <AuxiliaryText variant={"SubMenuDropdown"}>
                            Privacy Policy
                          </AuxiliaryText>
                        </Link>
                      </li>
                    </ul>
                  </>
                )}
                <Link
                  to="/"
                  onClick={() => {
                    setAuth({ user: null, roles: null, accessToken: "" });
                    localStorage.removeItem("LoginSession");
                    toggleDrawer();
                  }}
                  className="block py-2  hover:text-primaryblue  px-2"
                >
                  <AuxiliaryText variant={"MenuDropdown"}>
                    Sign out
                  </AuxiliaryText>
                </Link>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CustomerNavbar;
// <div className="w-8 h-8 bg-pink rounded-full mr-4 flex justify-center items-end">
//   <IconContext.Provider value={{ className: `text-xl mb-1` }}>
//     <User
//       onClick={() =>
//         setAuth({ user: null, roles: null, accessToken: "" })
//       }
//     />
//   </IconContext.Provider>
// </div>
